<template>
  <div class="DecoratorLine"></div>
</template>

<script>
export default {
  name: "DecoratorLine",
};
</script>

<style scoped>
.DecoratorLine {
  margin-bottom: 5px;
  margin-left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 2px;
  background: #9a1b1e;
  border-radius: 1px;
}
</style>
